export default __webpack_public_path__ + "static/media/P-032.37501aba.png";